import React from "react";
import { Link } from "react-router-dom";
import styles from "./Dienstleistungen.module.css";
import BackToTop from "../components/BackToTop";
import { useInView } from "../Hooks/useInView";
import {
  Building2,
  Ruler,
  ClipboardList,
  TrendingUp,
  Wrench,
  CalendarCheck,
} from "lucide-react";

import HeroPlate from "../components/HeroPlate";
import { categories, type Category } from "../data/dienstleistungenData";

const isSplashActive = () =>
  typeof document !== "undefined" &&
  document.documentElement.classList.contains("splash-active");


const iconsMap: Record<Category["id"], React.ReactNode> = {
  projektentwicklung: <Building2 size={22} className={styles.glowIcon} />,
  "projektleitung-steuerung": <Ruler size={22} className={styles.glowIcon} />,
  projektmanagement: <ClipboardList size={22} className={styles.glowIcon} />,
  "vertrieb-und-vermarktung": (
    <TrendingUp size={22} className={styles.glowIcon} />
  ),
  "objektbetreuung-gewahrleistungsmanagement": (
    <Wrench size={22} className={styles.glowIcon} />
  ),
  "veranstaltungsorganisation-fur-bauprojekte": (
    <CalendarCheck size={22} className={styles.glowIcon} />
  ),
};

const Dienstleistungen: React.FC = () => {
  const [descRef, descInView] = useInView<HTMLDivElement>(0.35);
  const splashActive = isSplashActive();

  return (
    <main className={styles.servicesPage}>

      <HeroPlate
        variant="plate-left" 
        tone="light"
        media={{
          kind: "image",
          src: "/media/images/dienstleistungen.webp",
          alt: "Dienstleistungen",
        }}
        kicker="Dienstleistungen"
        title="Kompetenz aus einer Hand – von der Idee bis zur Realisierung."

      />

      <div className={styles.inner}>
        <header className={styles.header}>
          <h2 className={styles.sectionTitle}>Unsere Dienstleistungen</h2>

          <div
            ref={descRef}
         className={`${styles.introText} ${
  descInView && !splashActive ? styles.descVisible : ""
}`}

          >
            <p>
              Wir begleiten Immobilienprojekte in jeder Phase:
              <br></br>
              als Projektmanager mit strategischem Weitblick, als Projektsteurer
              mit klarer Struktur und operativer Stärke.
              <br></br>
              Unsere Leistungen sind modular aufgebaut und individuell
              kombinierbar – exakt abgestimmt auf die Anforderungen unserer
              Bauherren.
              <br></br>
              Von der ersten Idee bis zum erfolgreichen Abschluss – wir denken
              Projekte ganzheitlich.
            </p>
          </div>
        </header>

        <nav className={styles.accordionList} aria-label="Leistungen">
          {categories.map(({ id, title, tagline }) => {
            const icon = iconsMap[id] ?? (
              <ClipboardList size={22} className={styles.glowIcon} />
            );
            return (
              <div key={id} className={styles.accordionItem}>
                <Link
                  to={`/dienstleistungen/${id}`}
                  className={styles.accordionLink}
                  aria-label={`${title} – Details`}
                >
                  <div className={styles.headerContent}>
                    <span
                      className={styles.accordionTitleIcon}
                      aria-hidden="true"
                    >
                      {icon}
                    </span>
                    <h2 className={styles.accordionTitle}>{title}</h2>
                    {tagline && (
                      <p className={styles.detailTagline}>{tagline}</p>
                    )}
                  </div>

                  <span className={styles.accordionArrow} aria-hidden="true">
                    ›
                  </span>
                </Link>
              </div>
            );
          })}
        </nav>
      </div>

      <BackToTop />
    </main>
  );
};

export default Dienstleistungen;
